// extracted by mini-css-extract-plugin
module.exports = {"list":"Statistics_list__1ZYXT"};